// extracted by css-extract-rspack-plugin
export default {"cls1":"SourcePaperCard-cls1_v1h","cls2":"SourcePaperCard-cls2_DB8 SourcePaperCard-cls1_v1h"};